import React, { useState, useEffect } from "react";
import "../TableStyles.css"

import doubleVenn from '../tableImages/doubleVenn.png';
import doubleVennNA from '../tableImages/doubleVennNA.png';
import { Link } from 'react-router-dom';
import { useParams } from "react-router-dom/cjs/react-router-dom.min";


function DocMatchOne(props){

    const {resid, reportName} = useParams();
    const {lcChain, hclcChain, hcChain, collName} = props

    useEffect(() =>{
    },[props])

    function applyMatchingPNs(totalQueries){
        for(var i=0; i< totalQueries.length; i++){
            totalQueries[i] = totalQueries[i].toUpperCase();
            totalQueries[i] = totalQueries[i].replaceAll('-','_');
        }
        var abReportFilters = {
            matchingDocuments: totalQueries,
            reportName: decodeURIComponent(reportName) == "undefined"? "Unfiltered_Entire_Report": decodeURIComponent(reportName),
            groupBy: 'document'
        };
        
        return encodeURIComponent(JSON.stringify(abReportFilters))
    }

	return (
        <div className="tableFrame">
            <p className="textFlat pCenter" style={{paddingTop: "13px"}}><strong>DOCUMENTS</strong> matching at least one of the chains</p>
            <div style={{width: "100%", height: "159px", position: "relative"}}>
            {lcChain > 0 &&
            <div className="textL">
             <Link 
                style={{zIndex:"251"}}
                className={lcChain == 0? "disabled":""}                        
                target="_blank"
                disabled={lcChain == 0} 
                to={{
                    pathname: '/discover/wf:'+resid+".resdb/antibody/"+applyMatchingPNs(['LC']) + "/" + collName
                }}>{lcChain}
             </Link>
             </div>
            }
            {hclcChain > 0 &&
            <div className="textM">
                <Link 
                    style={{zIndex:"251"}}
                    className={hclcChain == 0? "disabled":""}                         
                    target="_blank"
                    disabled={hclcChain == 0} 
                    to={{
                        pathname: '/discover/wf:'+resid+".resdb/antibody/"+applyMatchingPNs(['LC','HC']) + "/" + collName
                    }}>{hclcChain}
                </Link>
            </div>
            }
            {hcChain > 0 &&
            <div className="textR">
                <Link 
                    style={{zIndex:"251"}}
                    className={hcChain == 0? "disabled":""}
                    target="_blank"
                    disabled={hcChain == 0} 
                    to={{
                        pathname: '/discover/wf:'+resid+".resdb/antibody/"+applyMatchingPNs(['HC']) + "/" + collName
                    }}>{hcChain}
                </Link>
            </div>
            }
                <span style={{left :"123px"}} className="Circle CircleOrange">
                </span>
                <span style={{right :"123px"}} className={hcChain > 0 ? "Circle CircleBlue" : "Circle CircleNA"}>
                </span>
            </div>
            
        <div style={{ width: "100%", display: "flex", justifyContent: "center"}}>
            <span style={{padding: "0 10px"}}>Light Chain</span><span style={{padding: "0 10px"}}>Heavy Chain</span>
        </div>
        <p className="bottomText pCenter">The number of patent documents matching chain sequences. Click the numbers to see the results.</p>
    </div>
    );
}

export default DocMatchOne;
